import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as Keycloak from "keycloak-js";
import VueLogger from "vuejs-logger";
import KeycloakConfig from "./config/keycloak.json";
import moment from "moment";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.config.productionTip = false;

const options = {
  isEnabled: true,
  logLevel: Vue.config.productionTip ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};
Vue.use(VueLogger, options);

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
Vue.axios.interceptors.request.use(
  function(config) {
    let authToken = localStorage.getItem("krj-token");
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

Vue.prototype.$moment = moment;

KeycloakConfig.url = process.env.VUE_APP_KEYCLOAK_API;
let keycloak = Keycloak(KeycloakConfig);

keycloak
  .init({
    onLoad: KeycloakConfig.onLoad,
    checkLoginIframe: KeycloakConfig.checkLoginIframe
  })
  .success(auth => {
    if (!auth) {
      window.location.reload();
    }

    if (keycloak.hasRealmRole("OPERATOR")) {
      keycloak.logout({ redirectUri: process.env.VUE_APP_WEB_UI });
      return;
    }
    Vue.prototype.$keycloak = keycloak;
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");

    localStorage.setItem("krj-token", keycloak.token);
    localStorage.setItem("krj-refresh-token", keycloak.refreshToken);
  })
  .error(() => {
    Vue.$log.error("Authenticated Failed");
  });
